<template>
  <div class="tg-box">
    <img src="@/assets/24_jzs1_bg.jpg" alt="" class="bg">
    <div class="form-box">
      <van-form ref="vanForm" label-width="44px" :show-error-message="false">
        <van-field v-model="name" name="姓 名" label="姓名">
        </van-field>
        <van-field v-model="mobile" name="手机号" label="手机号" required>
        </van-field>
        <van-field class="code" center v-model="msg" type="text" name="验证码" label="验证码" required>
          <template #button>
            <van-button size="small" class="sms-code" type="primary" hairline @click="getCode">
              {{codeTime === 60 ? '发送验证码' :`再次发送（${codeTime}）`}}
            </van-button>
          </template>
        </van-field>
      </van-form>

      <van-button type="primary" size="large" class="submit" @click="onSubmit">速领全科估分直播课</van-button>
    </div>
    <div class="bottom"></div>
  </div>
</template>
<script>
import $ from "jquery";
import md5 from "js-md5";
import { Toast } from "vant";
import { examSync, sendMsg } from "@/api/index";
export default {
  data() {
    return {
      name: "",
      mobile: "",
      msg: "",
      codeLoad: false,
    };
  },
  computed: {
    codeTime() {
      return this.$store.state.codeTime;
    },
  },
  methods: {
    phoneValidator(val) {
      return /^1[34578]\d{9}$/.test(val);
    },
    getCode() {
      if (this.codeLoad || this.codeTime != 60) {
        return;
      }
      if (!this.phoneValidator(this.mobile)) {
        Toast("请输入正确手机号");
        return;
      }
      this.codeLoad = true;
      this.$API
        .sendMsg({
          phone: this.mobile,
          type: 1,
          corpId: "123456789",
        })
        .then((res) => {
          this.$store.dispatch("codeTime");
        })
        .finally(() => {
          setTimeout(() => {
            this.codeLoad = false;
          }, 2000);
        });
    },
    onSubmit() {
      if (!this.mobile.length) {
        Toast("请填写手机号");
        return;
      }
      if (!this.phoneValidator(this.mobile)) {
        Toast("请填写正确手机号");
        return;
      }
      if (!this.msg.length) {
        Toast("请填写验证码");
        return;
      }
      this.$refs.vanForm.validate().then((res) => {
        const gt = new Date().getTime().toString();
        examSync({
          time: gt,
          encryPwd: md5(gt + "verify"),
          name: this.name,
          mobile: this.mobile,
          msg: this.msg,
          labels:'2024一建考场',
          collegeName: "一级建造师",
          orign: "考场宣传",
        }).then((res) => {
          if (res.code == 200) {
            Toast("领取成功");
            $("html,body").animate(
              {
                scrollTop: $(".bottom").offset().top + "px",
              },
              500
            );
          }
        });
      });
    },
  },
  mounted() {
  },
};
</script>
<style lang="stylus" scoped>
.tg-box {
  position: relative;

  .form-box {
    position: absolute;
    top: 7.95rem;
    left: 50%;
    transform: translateX(-50%);
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 7.3rem;
    height: 6rem;

    ::v-deep .van-cell {
      height: 1.386666rem;
      background: none

      &:after {
        display: none;
      }

      &::before {
        top: 14px;
      }

      .van-field__label {
        display: flex;
        align-items: center;
        color: #333333;

        span {
          display: inline-block;
          width: 70px;
          text-align-last: justify;
        }
      }

      .van-field__control {
        border: 1px solid #dcdcdc;
        border-radius: 5px;
        height: 0.85333rem;
        padding-left: 5px;
        box-sizing: border-box;
        color: #333333;
      }
    }

    .sms-code {
      background: #1f52e1;
      border: none;
      border-radius: 5px;
    }

    .submit {
      width: 6.5rem;
      height: 0.85333rem;
      margin-top: 0.39999rem;
      font-weight: 800;
      color: #fff;
      background: #1f52e1;
      border: none;
      border-radius: 5px;
    }
  }

  .bottom-box {
    position: absolute;
    bottom: 7.8rem;
    left: 50%;
    transform: translateX(-50%);
  }
}
</style>